// ===== Colors
export const BG_BUTTON_BLUE = 'rgba(94, 153, 245, 1)';
export const BG_BUTTON_BLUE_LIGHT = 'rgba(94, 153, 245, 0.5)';
export const BG_BUTTON_WHITE = 'rgba(255, 255, 255, 1)';
export const BG_BUTTON_GRAY = 'rgba(237, 237, 237, 1)';
export const BG_BUTTON_GRAY_DARK = 'rgba(216, 216, 216, 1)';

// ===== Borders
export const BORDER_BUTTON_BLUE = '1px solid rgba(94, 153, 245, 1)';
export const BORDER_BUTTON_GRAY = '1px solid rgba(181, 181, 181, 1)';
export const BORDER_BUTTON_GRAY_BOLD = '2px solid rgba(216, 216, 216, 1)';
export const BORDER_BUTTON_RED = '1px solid rgb(226, 118, 37)';
